<div>
  <button class="btn btn-primary mb-2" routerLink="/admin/actions/systemPromocode/add">Create Promo</button>
  <app-base-report [filterFields]="filterField"
                   [hasCheckboxes]="false"
                   [reportName]="'System Promocode Mangement'"
                   [defaultColumns]="Columns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="systemPromocodeReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChance($event)"
                   [tableLoading]="loading"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="fetchSystemPromocodeService"
                   [rowActions]="rowActions"
                   (rowActionClicked)="onRowAction($event)">
  </app-base-report>
</div>
